import LineProgress from './line-progress';

export default LineProgress;
